import { render, staticRenderFns } from "./DashboardGeral.vue?vue&type=template&id=299ce25c&"
import script from "./DashboardGeral.vue?vue&type=script&lang=js&"
export * from "./DashboardGeral.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGeral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports